/**
 * Utility functions for formatting data
 * Extracted from StudentList and other components for reusability
 */

/**
 * Format a date string to a localized date format
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date or "—" if invalid
 */
export const formatDate = (dateString) => {
  if (!dateString) return "—";
  try {
    return new Date(dateString).toLocaleDateString();
  } catch (error) {
    return "—";
  }
};

/**
 * Format a boolean value to "Yes" or "No"
 * @param {boolean|null|undefined} value - Boolean value
 * @returns {string} "Yes", "No", or "—"
 */
export const formatBoolean = (value) => {
  if (value === null || value === undefined) return "—";
  return value ? "Yes" : "No";
};

/**
 * Format a URL to ensure it has a protocol
 * @param {string} url - URL string
 * @returns {string} URL with https:// prefix if needed
 */
export const formatUrl = (url) => {
  if (!url || url === "—") return url;
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `https://${url}`;
};

/**
 * Normalize a value to handle string "undefined" and "null"
 * @param {*} value - Any value
 * @returns {*} Normalized value or null
 */
export const normalizeValue = (value) => {
  if (value === "undefined" || value === "null" || value === null || value === undefined) {
    return null;
  }
  return value;
};



